import PersonGroupsTable from './PersonGroupsTable';

export default PersonGroupsTable;
